import React from 'react';
import Footer from '../components/footer';
//Redux
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ExploreProduct from "../components/ExploreProduct"

import * as actionCreators from '../store/actions';
import { Container, Row } from 'react-bootstrap';
import isEmpty from 'lodash/isEmpty';
import isNull from 'lodash/isNull';
import ReactLoading from 'react-loading';
import $ from 'jquery';

import isStringArabic from '../store/isStringArabic';
import CartMenu from '../components/CartMenu';
import SubscribedNavbar from "../components/SubscribedNavbar"


class ProductsByCategory extends React.Component {
  state = {
    showPowerText: false,
    menuExpaned: null,
    bucketExpaned: null
  }
  componentDidMount() {
    window.scrollTo(0, 0)
    // setTimeout(() => {
    // 	this.setState({
    // 		showPowerText: true
    // 	})
    // }, 3000)
    this.props.setUserLocation()
    const { pathname } = this.props.location;

    // this.props.getLanguageListPOEdit(pathname === "/ar" ? "ar" : "en")
    this.props.getLanguageListPOEdit(pathname === "/clientwebsite2/ar" ? "ar" : "en")

    this.props.savePathName(pathname)
    if (isEmpty(this.props.instagramAccountInfo.brandName))
      this.props.getInstagramAccountDetail(this.props.history);

    this.props.myCartList()
  }
  componentDidUpdate(prevProps) {
    if (
      !isNull(this.props.instagramAccountInfo.snap_pixel_script) &&
      !isEmpty(this.props.instagramAccountInfo.snap_pixel_script) &&
      prevProps.instagramAccountInfo.snap_pixel_script !== this.props.instagramAccountInfo.snap_pixel_script
    ) {
      var embedCode = this.props.instagramAccountInfo.snap_pixel_script; // <script>//my js script code</script>
      $('head').append(embedCode);
    }
  }
  errorLoadingPicture = (error) => {
    const { businessid, insta_handle } = this.props.instagramAccountInfo
    this.props.updateBusinessLogo(businessid, insta_handle)
  }
  changeLanguage = () => {
    if (this.props.language === "en") {
      // this.props.history.replace("/ar")
      this.props.history.replace("/clientwebsite2/ar")

    } else {
      this.props.history.replace("/")
    }
  }
  closeCartMenu = () => {
    this.setState({
      bucketExpaned: false
    })
  }
  expandBucket = () => {
    this.setState({
      bucketExpaned: true
    })
  }
  render() {
    const translate = this.props.translate
    document.body.classList.remove('inner-page');

    // console.log('this.props.instagramAccountInfo', this.props.instagramAccountInfo);
    // console.log(' this.props.pathname', this.props.pathname);
    if (this.props.loadingInstaDetail) {
      return (
        <div className="outerDiv">
          <ReactLoading type="spin" color="#FF9D00" />
        </div>
      );
    }
    return (
      <div className="outerDiv">
        {/* <div className={`topNavBar ${this.props.language === "ar" && "topNavBarRTL"}`}
          style={{
            filter: window.innerWidth <= 991 && (this.state.menuExpaned || this.state.bucketExpaned) ? "blur(5px)" : "none"
          }}
        >

          <Row className="brandImageRow">
            <Image className="brandImage" src={this.props.instagramAccountInfo.brandProfilePic} onError={this.errorLoadingPicture} />
          </Row>
          <Row
            className="brandNameText"
            style={{
              fontFamily: isStringArabic(this.props.instagramAccountInfo.brandName)
                ? 'Changa-bold'
                : 'Montserrat-bold',
            }}
          >
            {this.props.instagramAccountInfo.brandName}
          </Row>
          
          <p onClick={this.changeLanguage} className={`languageButton ${this.props.language === "en" && "arabic"} ${this.props.language === "ar" && " languageButtonRTL"}`} >
            {this.props.language === "en" ? "العربية" : "English"}
          </p>
        </div>
       */}
        <SubscribedNavbar
          categories={this.props.categories}
          translate={this.props.translate}
          instagramAccountInfo={this.props.instagramAccountInfo}
          cartList={this.props.cartList}
          expandBucket={this.expandBucket}
          language={this.props.language}
					history={this.props.history}
        />
        <CartMenu
          currency={this.props.currency}
          translate={this.props.translate}
          cartList={this.props.cartList}
          closeCartMenu={this.closeCartMenu}
          bucketExpaned={this.state.bucketExpaned}
        />
        {
          this.props.instagramAccountInfo.businessName !== "shaheenmusic" &&
          <div className={"mainBodyOuterDiv"} style={{
            filter: window.innerWidth <= 1024 && (this.state.menuExpaned || this.state.bucketExpaned) ? "blur(5px)" : "none"
          }}
            onClick={() => {
              if (this.state.menuExpaned) {
                this.setState({
                  menuExpaned: false
                })
              }
              if (this.state.bucketExpaned) {
                this.setState({
                  bucketExpaned: false
                })
              }
            }}
          >



            {this.props.explore_products && this.props.explore_products.length > 0 &&
              <div style={{ width: '100%' }} >
                <h4 className={`headingText ${this.props.language === "ar" && "headingTextRTL"} `} style={{ fontFamily: isStringArabic(translate[this.props.instagramAccountInfo.web_heading_key_name]) ? "Changa-bold" : "Montserrat-bold" }}>
                  {translate[this.props.instagramAccountInfo.web_heading_key_name]}
                </h4>
                <Container className="productsListContainer">
                  <Row className="productsListRow">
                    {this.props.explore_products.map(product => (
                      <ExploreProduct
                        key={product.id}
                        media={product}
                        businessName={this.props.instagramAccountInfo.businessName}
                        whatsappLink={this.props.instagramAccountInfo.whatsappLink}
                        currency={this.props.currency}
                        translate={this.props.translate}
                        language={this.props.language}
                      />
                    ))}

                  </Row>
                </Container>
              </div>
            }



          </div>

        }




        {/*Footer Component*/}
        <Footer
          translate={this.props.translate}
          imagesList={this.props.instagramAccountInfo.imagesList}
          explore_products={this.props.explore_products} />

        {/*tap-top*/}
        {/* <div className="tap-top">
					<div>
						<i className="fa fa-angle-up" aria-hidden="true" />
					</div>
				</div> */}
      </div >
    );
  }
}
const mapDispatchToProps = dispatch => ({
  getInstagramAccountDetail: history => dispatch(actionCreators.getInstagramAccountDetail(history)),
  loadMoreInstagramPost: (instaHandleId, instaEndCursor) => dispatch(actionCreators.loadMoreInstagramPost(instaHandleId, instaEndCursor)),
  savePathName: pathname => dispatch(actionCreators.savePathName(pathname)),
  updateBusinessLogo: (businessid, insta_handle) => dispatch(actionCreators.updateBusinessLogo(businessid, insta_handle)),
  getLanguageListPOEdit: (language) => dispatch(actionCreators.getLanguageListPOEdit(language)),
  setUserLocation: () => dispatch(actionCreators.setUserLocation()),
  myCartList: () => dispatch(actionCreators.myCartList()),
});
const mapStateToProps = state => ({
  language: state.websiteLanguage.language,
  instagramAccountInfo: state.campaign.instagramAccountInfo,
  errorMessage: state.campaign.errorMessage,
  loadingInstaDetail: state.campaign.loadingInstaDetail,
  no_of_products_to_show: state.campaign.no_of_products_to_show,
  pathname: state.login.pathname,
  translate: state.websiteLanguage.translations,
  explore_products: state.campaign.explore_products,
  currency: state.login.currency,
  cartList: state.cart.cartList,
  categories: state.campaign.categories
});
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ProductsByCategory)
);



// WEBPACK FOOTER //
// ./src/pages/ProductsByCategory.js